export default function PageHero({ eyebrow, title, intro, children }) {
  return (
    <section className="relative overflow-hidden bg-navy-deep text-white" data-testid="page-hero">
      <div className="absolute inset-0 grid-bg opacity-[0.07]" aria-hidden />
      <div className="absolute top-0 left-0 right-0 h-px bg-safety/70" aria-hidden />
      <div className="container-rail py-20 md:py-28 relative">
        {eyebrow && (
          <p className="label-eyebrow text-safety mb-6 fade-up">{eyebrow}</p>
        )}
        <h1 className="font-display font-bold text-balance text-4xl sm:text-5xl lg:text-6xl text-white max-w-4xl leading-[1.05] fade-up fade-up-delay-1">
          {title}
        </h1>
        {intro && (
          <p className="mt-6 max-w-2xl text-base md:text-lg text-slate-300 leading-relaxed fade-up fade-up-delay-2">
            {intro}
          </p>
        )}
        {children && <div className="mt-10 fade-up fade-up-delay-3">{children}</div>}
      </div>
      <div className="h-1 w-full track-line bg-navy" aria-hidden />
    </section>
  );
}
